import Loading from "@components/loading/loading";

import { askAiEmbedItemClassName } from "./ask-ai-embeds";

const AskAIPlaceholderSuggestedArtifact = ({
  label,
  title,
  icon,
}: {
  label: string;
  title: string;
  icon: any;
}) => {
  return (
    <div className={askAiEmbedItemClassName}>
      <div className="flex flex-col gap-6">
        <div className="tf-header-sm-dark flex-1">{label}</div>
        <div className="flex group gap-2">
          <div className="mt-0.5">
            <span className="shrink-0">{icon}</span>
          </div>
          <div className="flex-1">
            <span className="font-medium text-left block">{title}</span>
          </div>
          <Loading mini size="5" />
        </div>
      </div>
    </div>
  );
};

export default AskAIPlaceholderSuggestedArtifact;
